import React from "react"
import UniversalLink from "@/components/common/Links/UniversalLink"
import CommonText from "@/components/common/Text"
import Icon from "@/components/common/Icon/Icon"
import { ICONS } from "@/constants"
import styled from "styled-components"
import { setIsMenuOpen } from "@/state/menuSlice"
import { useDispatch } from "react-redux"

const Text = styled(CommonText)`
	display: flex;
	align-items: center;

	.icon {
		margin-left: 5px;
		max-width: 10px;
	}
`
const LinkHeader = ({ isLink = false, url = "", children }) => {
	if (!isLink) return children
	return <UniversalLink href={url}>{children}</UniversalLink>
}

const Header = ({ isLink = false, url, arrow = false, square = true, color = "chineseViolet", children, ...props }) => {
	const dispatch = useDispatch()
	return (
		<LinkHeader isLink={isLink} url={url}>
			<Text
				onClick={() => dispatch(setIsMenuOpen(false))}
				tag={arrow ? "div" : "p"}
				className={`header ${square ? "square" : "disabled"} typo-borna typo-borna-42`}
				color={color}
				{...props}
			>
				{children}
				{arrow && <Icon name={ICONS.CHEVRON} color={color} />}
			</Text>
		</LinkHeader>
	)
}

export default Header
